export default {
    namespaced: true,
    state: () => ({
        filterPanelState: false,
        region: null,
        cities: [],
        city_id: null,
        search:'',
        tableOptions:
        {
            page: 1,
            itemsPerPage : 25,
            sortBy : [ "fullName" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : true
        },
        extendedFilter: null
    }),
    mutations: {
        SET_FILTER_PANEL_STATE(state, payload) {
            state.filterPanelState = payload;
        },
        SET_REGION(state, payload) {
            state.region = payload;
        },
        SET_CITIES(state, payload){
            state.cities = payload;
        },
        SET_CITY_ID(state, payload) {
            state.city_id = payload;
        },
        SET_SEARCH(state, payload) {
            state.search = payload;
        },
        SET_TABLE_OPTION(state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE(state, payload) {
            state.tableOptions.page = payload;
        },
        SET_EXTENDED_FILTER(state, payload) {
            state.extendedFilter = payload;
        },
    },
    getters: {
        getFilterPanelState: (s) => s.filterPanelState,
        getRegion: (s) => s.region,
        getCities: (s) => s.cities,
        getCityId: (s) => s.city_id,
        getSearch: (s) => s.search,
        getTableOptions: (s) => s.tableOptions,
        getExtendedFilter: (s) => s.extendedFilter,
    }
}